module.exports = __webpack_public_path__ + "img/valuationgood@2x.ec28cedb.png";